import { Cancel } from '@material-ui/icons'
import { useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import {
  Edit,
  EditProps,
  NumberInput,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { validatePrinterLayout } from './PrintLayoutsCreate'
import { ResourceName } from '../../core/ResourceName'
import FilteredReferenceInput from '../common/FilteredReferenceInput'

const EditTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.print-layouts.titles.edit')}</span>
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const PrintLayoutEdit = (props: EditProps) => {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Edit {...props} title={<EditTitle />} actions={false}>
      <SimpleForm
        redirect="show"
        validate={validatePrinterLayout}
        toolbar={<EditToolbar />}
      >
        <TextField source="id" label="Id" />
        <TextInput source="name" isRequired />
        <NumberInput source="width" isRequired />
        <NumberInput source="height" isRequired />
        <FilteredReferenceInput
          source="backgroundImageId"
          reference={ResourceName.FILES}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={smallScreen ? 5 : 15}
          filterSource="name"
          selectWithPaginationInputProps={{
            optionText: 'name',
            showFilter: true,
          }}
          filter={{
            fileExtension: '.jpg,.png,.jpeg,.bmp,.gif',
          }}
          isRequired
        />
      </SimpleForm>
    </Edit>
  )
}
